import { CKRadio } from '@clearkit/react';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { RadioGroup } from 'reakit/Radio';

import { hasError } from '~/lib/graphql';

import styles from './styles';

const TriggerType = ({
  classes,
  className,
  errors,
  handleChange,
  triggerType,
  triggerTypes,
}) => (
  <div className={classnames(classes.contentBox, className)}>
    <FormControl
      className={classes.formControl}
      error={hasError(errors, 'triggerType')}
      required>
      {hasError(errors, 'triggerType') && (
        <FormHelperText className={classes.errorText}>
          You must choose a trigger type
        </FormHelperText>
      )}

      <RadioGroup
        value={triggerType}
        aria-label="trigger type"
        onChange={(event) => {
          handleChange('triggerType', event.target.value);
        }}>
        <div className="flex flex-col space-y-2">
          {triggerTypes.map(({ value, label }) => (
            <CKRadio
              isDisabled={triggerTypes.length <= 1}
              key={value}
              id={value}
              value={value}
              label={label}
              checked={triggerType === value}
              classes={{ root: classes.radioRoot }}
            />
          ))}
        </div>
      </RadioGroup>
    </FormControl>
  </div>
);

TriggerType.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  errors: PropTypes.array,
  handleChange: PropTypes.func,
  triggerType: PropTypes.string,
  triggerTypes: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.node,
    }),
  ),
};

export default withStyles(styles)(TriggerType);
